export default {
    hasRole: (state) => (role) => {
        if (!Array.isArray(role)) return false

        if (state.user) {
            if (Array.isArray(state.user.authorities)) {
                return role.some(r => state.user.authorities.indexOf(r) !== -1)
            }
        }

        return false
    }
}